export default "/images/50c98c3bc7fd4bae96ab18c130992cec.png";